var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0c1.054 0 1.918.816 1.995 1.85L4 2v22.215l8.99-8.874a2.002 2.002 0 012.611-.173l.135.112 6.773 6.114L35.514 9.552a2.002 2.002 0 012.522-.14l.138.111 4.082 3.557 10.39-9.552a2 2 0 012.83 2.822l-.122.122-11.708 10.765a2 2 0 01-2.528.146l-.14-.11-4.088-3.563-13.028 11.863a2.002 2.002 0 01-2.548.12l-.138-.115-6.72-6.064L4 29.835V53h3V34h4v19h2V30h4v23h2V35h4v18h2V33h4v20h2V27h4v26h2V24h4v29h2V26h4v27h2V20h4v33h2c1.054 0 1.918.816 1.995 1.85L57 55a2.001 2.001 0 01-1.85 1.995L55 57H0V2a2 2 0 012-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

export default SvgStock;